<template>
  <UiDialog
    :value="value"
    :title="$t(title)"
    :width="width"
    top="var(--ui-space-lg)"
    :custom-class="resolvedCustomClass"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="!busy"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @input="updateVisible"
  >
    <template #title>
      <div class="ui-form-dialog__header">
        <span class="el-dialog__title ui-section-title has-icon">
          <i :class="titleIcon" aria-hidden="true"></i>{{ $t(title) }}</span>
        <UiStickyActions boundary-selector=".el-dialog">
          <slot name="actions" />
          <UiButton action="cancel" :disabled="busy" @click="cancel">{{ $t("取消") }}</UiButton>
        </UiStickyActions>
      </div>
    </template>
    <slot />
  </UiDialog>
</template>

<script>
export default {
  name: 'UiFormDialog',
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    mode: { type: String, required: true, validator: value => ['create', 'edit'].includes(value) },
    busy: { type: Boolean, default: false },
    width: { type: String, default: '600px' },
    customClass: { type: String, default: '' }
  },
  computed: {
    titleIcon () {
      return this.mode === 'create' ? 'el-icon-plus' : 'el-icon-edit'
    },
    resolvedCustomClass () {
      return ['ui-form-dialog', this.customClass].filter(Boolean).join(' ')
    },
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.input
      delete listeners['update:visible']
      return listeners
    }
  },
  methods: {
    updateVisible (visible) {
      this.$emit('input', visible)
      this.$emit('update:visible', visible)
    },
    cancel () {
      if (this.busy) return
      this.updateVisible(false)
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-form-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ui-space-lg);
  flex-wrap: wrap;
}
</style>
